

var _squid = require('squid');

var _route = require('../../confirm-upop/route');

var _route2 = _interopRequireDefault(_route);

require('./directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddCardRoute', function () {
    return _squid.$ComponentRoute.extend('AddCardRoute', {
        name: 'addCard',
        directive: 'xo-add-card',
        titleContent: 'asideHeader.addCard',

        trackingData: {
            fptiState: 'add_or_update_cc'
        },
        loginRequired: true,
        children: [{
            route: _route2['default'],
            attributes: {
                token: 'token',
                phone: 'phone',
                cardmodel: 'cardmodel',
                'on-success': 'onSuccess',
                'show-incentive': 'showIncentive',
                'incentive-amount': 'incentiveAmount'
            }
        }]
    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/addcard/route.js
// module id = ../node_modules/xo-wallet-components/src/add-card/addcard/route.js
// module chunks = 0